

function DataCard({ title, value, icon }) {
    return (
        <div className="rounded-xl border border-neutral-100 bg-white p-4 shadow-base">
            <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-light">
                    {icon}
                </div>
                <div>
                    <div className="text-xs font-semibold uppercase tracking-wide text-neutral-600">{title}</div>
                    <div className="text-2xl font-bold text-neutral-900">{value}</div>
                </div>
            </div>
        </div>
    );
}

export default DataCard;
